export class BrmStripePortalErrors {

  public static STRIPE_PORTAL_CUSTOMER_ID_MISSING = 'sec021';

}
